export enum TABLE {
    ACCOUNT = 'account',
    EMPLOYEE = 'employee',
    ADDRESS = 'address',
    ATTENTIVE_ACCOUNT = 'attentive_account',
    DRIP_ACCOUNT = 'drip_account',
    INSTRUMENT = 'instrument',
    BUSINESS_DETAILS = 'business_details',
    API_CREDENTIAL = 'api_credential',
    SHOPIFY_STORE = 'shopify_store',
    WOO_STORE = 'woo_store',
    AUTHORIZATION = 'charge_authorization',
    CHARGE = 'charge',
    REFUND = 'refund',
    CHECKOUT = 'checkout',
    SUBSCRIPTION = 'subscription',
    ORDER = 'orders',
    PAYPAL_ACCOUNT = 'paypal_account',
    PAYPAL_ORDER = 'paypal_order',
    MESSAGE = 'message',
    CUSTOM_FLOW = 'flow',
    FLOW_INSTANCE_GROUP = 'flow_instance_group',
    FLOW_TEMPLATE = 'flow_template',
    SHORT_URL = 'short_url',
    SHORT_TOKEN = 'short_token',
    INBOUND_KEYWORD = 'inbound_keyword',
    PROFILE_SETTINGS = 'profile_settings',
    POSTSCRIPT_APP = 'postscript_app',
    PERMISSION = 'permission',
    PARTIAL_CUSTOMER = 'partial_customer',
    TWILIO_ACCOUNT = 'twilio_account',
    TELNYX_ACCOUNT = 'telnyx_account',
    INFOBIP_ACCOUNT = 'infobip_account',
    KLAVIYO_ACCOUNT = 'klaviyo_account',
    STRIPE_ACCOUNT = 'stripe_account',
    BITLY_ACCOUNT = 'bitly_account',
    STRIPE_CHARGE = 'stripe_charge',
    STRIPE_CUSTOMER = 'stripe_customer',
    MAVERICK_ACCOUNT = 'maverick_account',
    MAVERICK_AUTHORIZATION = 'maverick_authorization',
    AUTHORIZE_DOT_NET_ACCOUNT = 'authorize_dot_net_account',
    AUTHORIZE_DOT_NET_TRANSACTION = 'authorize_dot_net_transaction',
    CUSTOM_CONTENT = 'custom_content',
    EVENT = 'event',
    PRICING_RULE = 'pricing_rule',
    FEE = 'fee',
    CREDIT = 'credit',
    FEE_AGGREGATE = 'fee_aggregate',
    ATTRIBUTION = 'attribution',
    SENDLANE_ACCOUNT = 'sendlane_account',
    YOTPO_ACCOUNT = 'yotpo_account',
    MERCHANT_FAQ = 'merchant_faq',
    META_ACCOUNT = 'meta_account',
    EXPERIMENT = 'experiment',
    EXPERIMENT_GROUP = 'experiment_group',
    EXPERIMENT_INSTANCE = 'experiment_instance',
    SEGMENT = 'segment',
    CUSTOMER_PROPERTY = 'customer_property',
    STAT_AGGREGATE = 'stat_aggregate',
    TRIGGER = 'trigger',
    MOCK_MESSAGE_PROVIDER = 'mock_message_provider',
    POPUP = 'popup',
    POPUP_TEMPLATE = 'popup_template',
    MEDIA_ASSET = 'media_asset',
    INTENT = 'intent',
    PRODUCT_EMBEDDING = 'product_embedding',
    OMNISEND_ACCOUNT = 'omnisend_account',
    SHOPIFY_PRODUCT = 'shopify_product',
    PRODUCT_CATEGORY = 'product_category',
    FLOW_LOG = 'flow_log'
}

export enum COLLECTION {
    SCHEDULED_TASK = 'scheduled_task',
    REQUEST = 'request',
    EVENT = 'event',
    LLM_LOG = 'llm_log',
    LLM_HOURLY_AGGREGATE = 'llm_hourly_aggregate',
    CUSTOM_FLOW_INSTANCE = 'custom_flow_instance',
    TEST = 'test'
}

export enum DATABASE_ERROR {
    UNKNOWN = 'unknown',
    DUPLICATE = 'duplicate',
    CONSTRAINT_ON_CONFLICT_NOT_FOUND = 'constraint_on_conflict_not_found',
    NOT_FOUND = 'not_found'
}

export const ONETEXT_ACCOUNT_ID_TRACKING_FRIENDLY = '00000000-0000-0000-0000-000000000000';

export enum CLICKHOUSE_TABLE {
    FEE = 'fee',

    MESSAGE_ATTRIBUTION = 'message_attribution',
    FLOW_ATTRIBUTION = 'flow_attribution',
    EXPERIMENT_ATTRIBUTION = 'experiment_attribution',

    MESSAGE_STAT = 'message_stat',
    PUBLIC_EVENT = 'public_event'
}

export enum CLICKHOUSE_TYPE {
    STRING = 'String',
    UINT8 = 'UInt8',
    UINT16 = 'UInt16',
    UINT32 = 'UInt32',
    UINT64 = 'UInt64',
    INT8 = 'Int8',
    INT16 = 'Int16',
    INT32 = 'Int32',
    INT64 = 'Int64',
    FLOAT32 = 'Float32',
    FLOAT64 = 'Float64',
    DATETIME = 'DateTime',
    DATETIME64 = 'DateTime64',
    DATE = 'Date',
    ENUM8 = 'Enum8',
    ENUM16 = 'Enum16',
    UUID = 'UUID',
    IP = 'IPv4',
    BOOLEAN = 'Bool'
}

export const CLICKHOUSE_ENUM_TYPES = [
    CLICKHOUSE_TYPE.ENUM8,
    CLICKHOUSE_TYPE.ENUM16
] as const;

export type ClickhouseEnumType = typeof CLICKHOUSE_ENUM_TYPES[number];

export enum CLICKHOUSE_MODIFIER {
    NULLABLE = 'Nullable'
}

export enum DYNAMODB_TABLE {
    SCHEDULED_TASK = 'scheduled_task'
}

export enum DYNAMODB_TABLE_SCHEDULED_TASK_INDEX {
    CANCELID_STATUS_INDEX = 'cancelid_status_index'
}

export type DYNAMODB_INDEX = {
    [DYNAMODB_TABLE.SCHEDULED_TASK] : DYNAMODB_TABLE_SCHEDULED_TASK_INDEX,
};

export type DynamoDBKeyValue = Record<string, string | number | boolean>;

export type DynamoDBCancelIdStatusIndexProjection = {
    id : string,
};

export enum DYNAMODB_QUERY_EXPRESSION {
    AND = 'and',
    COMMA = ','
}

export enum DYNAMODB_QUERY_CONDITION {
    ATTRIBUTE_EXISTS = 'attribute_exists'
}
